import { Alert, Slide, Snackbar } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleAlert } from "redux/festures/alertSlice";
import MDSnackbar from "./MDSnackbar";
// import { handleAlert } from "../../redux/AlertsTostify/alertSlice";

function TransitionLeft(props) {
  return <Slide {...props} direction="Top" />;
}
const AlertTost = () => {
  const { alerts } = useSelector((state) => state.isAlert) || {};
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const pending = sessionStorage.getItem("pending_alert");
      if (pending) {
        sessionStorage.removeItem("pending_alert");
        const parsed = JSON.parse(pending);
        if (parsed?.msg) {
          dispatch(
            handleAlert({
              isOpen: true,
              type: parsed.type || "error",
              msg: parsed.msg,
            })
          );
        }
      }
    } catch (e) {
      sessionStorage.removeItem("pending_alert");
    }
  }, [dispatch]);

  useEffect(() => {
    if (alerts?.isOpen) {
      const timer = setTimeout(() => {
        dispatch(handleAlert({ ...alerts, isOpen: false }));
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [alerts?.isOpen]);
  return (
    <>
      <MDSnackbar
        color={alerts.type}
        icon={alerts.type === "success" ? "task_alt" : "error"}
        title="Admin_EasySolutions"
        content={alerts.msg}
        dateTime={""}
        open={alerts?.isOpen}
        close={() => dispatch(handleAlert({ ...alerts, isOpen: false }))}
      />
    </>
  );
};

export default AlertTost;
